import { render, staticRenderFns } from "./DdPpNotification.vue?vue&type=template&id=a447cf12&scoped=true&"
import script from "./DdPpNotification.vue?vue&type=script&lang=js&"
export * from "./DdPpNotification.vue?vue&type=script&lang=js&"
import style0 from "./DdPpNotification.vue?vue&type=style&index=0&id=a447cf12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a447cf12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VCol,VIcon,VRow})
